import { useQuery } from "@apollo/client/react";
import { FormattedMessage, useIntl } from "react-intl";
import { NoBackend } from "@/components/common/NoBackend";
import { HorizontalCardCarousel } from "@/components/design/HorizontalCardCarousel";
import { OpenListingsDocument, SortOrder } from "@/graphql/generated/operations";
import { userErrorMessage } from "@/lib/user-error";
import { ListingCard } from "@/pages/share/listings/ListingCard";

// Die Zeile "Offene Ausschreibungen" auf der SHARE-Seite, der Einstieg zum Bewerben: die neuesten
// Ausschreibungen, die genesis der Person zum Bewerben anbietet, dieselbe Auswahl wie auf
// /share/open-listings (@external-adr GENESIS-0087-application-phases-are-separate-from-decisions (GENESIS-0071 §5)).
const INPUT = { order: { publishedOn: SortOrder.Desc }, first: 8 };

export function OpenListingsShareRow() {
  const intl = useIntl();
  const { data, loading, error } = useQuery(OpenListingsDocument, { variables: { input: INPUT } });
  const listings = data?.openListings.nodes ?? [];

  if (loading && listings.length === 0) {
    return (
      <div className="box bg-surface p-5 smycles-field-meta text-ink-muted" aria-busy="true">
        <FormattedMessage id="common.loading" defaultMessage="Laden…" />
      </div>
    );
  }
  if (error && listings.length === 0) {
    return (
      <p role="alert" className="text-smycles-label text-ink-muted">
        <FormattedMessage
          id="share.landing.error"
          defaultMessage="Error: {message}"
          values={{ message: userErrorMessage(intl, error) }}
        />
      </p>
    );
  }
  if (listings.length === 0) {
    return (
      <NoBackend
        label={intl.formatMessage({
          id: "share.openListings.empty",
          defaultMessage: "Gerade ist keine Ausschreibung offen",
        })}
      />
    );
  }
  return (
    <HorizontalCardCarousel>
      {listings.map((listing, index) => (
        <div key={listing.id} className="w-64 shrink-0">
          <ListingCard listing={listing} index={index} to={`/share/open-listings/${listing.id}`} />
        </div>
      ))}
    </HorizontalCardCarousel>
  );
}
